// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__zi3GY","header":"Messages_header__1XNZD"};